module.exports = __webpack_public_path__ + "static/img/help_10class_02.17ae3a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_10class_02.jpg
// module id = 712
// module chunks = 140